module.exports = __webpack_public_path__ + "img/cloud_agent_sensor.0c838dce.png";